export type ReviewOpenFocus = "case" | "letter";
export type ReviewOpenMode = "review" | "progress";

export type OpenHomeTaskOptions = {
  focus?: ReviewOpenFocus;
  mode?: ReviewOpenMode;
};

export function buildTaskReviewPath(
  taskId: string,
  options?: Pick<OpenHomeTaskOptions, "focus" | "mode">,
): string {
  const base = `/review/${encodeURIComponent(taskId)}`;
  const params = new URLSearchParams();
  if (options?.focus === "letter") {
    params.set("focus", "letter");
  }
  if (options?.mode === "progress") {
    params.set("mode", "progress");
  }
  const search = params.toString();
  return search ? `${base}?${search}` : base;
}

export function parseReviewOpenFocus(value: string | null | undefined): ReviewOpenFocus {
  return value === "letter" ? "letter" : "case";
}

export function parseReviewOpenMode(value: string | null | undefined): ReviewOpenMode {
  return value === "progress" ? "progress" : "review";
}
